import { useState, useEffect } from "react";
import axios from "axios";
import { CloudRain } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Bannière Mode Pluie Dakar — poll /api/weather/rain-status toutes les 2 min
export default function RainSurgeBanner({ compact = false }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const r = await axios.get(`${BACKEND_URL}/api/weather/rain-status`);
        if (!cancelled) setStatus(r.data);
      } catch (e) {
        // silencieux : la bannière ne doit jamais bloquer l'UI
      }
    };
    fetchStatus();
    const t = setInterval(fetchStatus, 120000); // 2 min
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!status?.is_raining) return null;
  const surge = status.surge_multiplier || 1.3;
  const surgePct = Math.round((surge - 1) * 100);
  const isManual = status.source === "manual_admin";

  if (compact) {
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-500/10 border border-sky-500/40 text-sky-200 text-xs font-bold uppercase tracking-widest"
        data-testid="rain-surge-badge"
      >
        <CloudRain className="w-3.5 h-3.5" />
        Mode Pluie +{surgePct}%
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl border-2 border-sky-400/50 bg-gradient-to-r from-sky-500/15 to-blue-700/20 px-4 py-3 flex items-center gap-3"
      data-testid="rain-surge-banner"
    >
      <div className="w-10 h-10 rounded-xl bg-sky-500/30 flex items-center justify-center flex-shrink-0">
        <CloudRain className="w-5 h-5 text-sky-300" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-black text-sm text-white">
          🌧️ Mode Pluie Dakar actif · surcharge +{surgePct}%
        </p>
        <p className="text-[11px] text-sky-200/80">
          {isManual
            ? "Activé par l'admin pour compenser les chauffeurs"
            : `Détection auto Open-Meteo · ${status.precipitation_mm?.toFixed?.(1) || 0} mm/h`}
        </p>
      </div>
    </div>
  );
}
